import { styled } from '@mui/material'
import { TTheme } from '@/core/theme'

export const SwitchContainer = styled('div')`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
`

export const SwitchRoot = styled('label')<{
    theme?: TTheme
    disabled?: boolean
}>`
    position: relative;
    display: inline-block;
    width: 48px;
    height: 24px;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`

export const SwitchInput = styled('input')`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    margin: 0;
    cursor: inherit;
`

export const SwitchTrack = styled('span')<{
    theme?: TTheme
    checked?: boolean
}>`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background: ${({ theme, checked }) =>
        checked ? theme.colors.primary[400] : theme.colors.primary[50]};
    transition: background 250ms cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
`

export const SwitchThumb = styled('span')<{
    theme?: TTheme
    checked?: boolean
}>`
    position: relative;
    display: block;
    width: 16px;
    height: 16px;
    top: 4px;
    left: ${({ checked }) => (checked ? '28px' : '4px')};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.greys[0]};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    transition: left 250ms cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
`

export const SwitchText = styled('span')<{ isOn: boolean; theme?: TTheme }>`
    font-size: ${({ theme }) => theme.fonts['s-regular'].fontSize};
    line-height: 16px;
    color: ${({ theme, isOn }) =>
        isOn ? theme.colors.greys[900] : theme.colors.greys[700]};
`
